import React, { useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  InputNumber,
  Modal,
  Row,
  Upload
} from 'antd'
import _, { isEmpty, isNull, isUndefined } from 'lodash'
import {
  beforeUpload,
  compressFile,
  getBase64
} from '../../../utils/services'
import { useDeepEffect } from '../../../utils/hooks'
import { SelectMaterialDiv } from '../../../styles/shared.style'
import BarcodeMaterialModal from '../BarcodeMaterialModal'
import axios from 'axios'
import SelectImg from '../../../assets/images/select_item.png'
import AddMaterialImg from '../../../assets/images/add_material_icon.png'

const BrandGuideItem = ({ formData, visible, onCancel, onOk, form }) => {
  const {
    validateFields,
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    resetFields
  } = form

  getFieldDecorator('keys', { initialValue: [] })
  const keys = getFieldValue('keys')
  const [formImg, setFormImg] = useState([])
  const [materialForm, setMaterialForm] = useState({})
  const [visibleAddMaterial, setVisibleAddMaterial] = useState(false)
  const [coverImageUrl, setCoverImageUrl] = useState("")

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      if (!isEmpty(formData.brandGuideItemList)) {
        const arr = formData.brandGuideItemList.map((item) => {
          return {
            materialId: item.materialId,
            materialName: item.materialName,
            materialImageUrl: item.materialImageUrl,
            id: item.id
          }
        })
        setFieldsValue({
          keys: arr
        })
        setFormImg([])
      } else {
        setFieldsValue({
          keys: []
        })
      }
      setFieldsValue({
        name: formData.name,
        brand: formData.brand,
      })
      setCoverImageUrl(formData.barcodeImage)
    }
  }, [formData])

  console.log(formData)

  useDeepEffect(() => {
    setTimeout(() => {
      if (!isEmpty(keys) && !isEmpty(formData)) {
        for (let i = 0; i < formData.brandGuideItemList.length; i++) {
          setFieldsValue({
            [`recycleDetails[${formData.brandGuideItemList[i].id}]`]:
              formData.brandGuideItemList[i].recycleDetail,
            [`weights[${formData.brandGuideItemList[i].id}]`]:
              formData.brandGuideItemList[i].weight,
            [`images[${formData.brandGuideItemList[i].id}]`]: new File(
              [],
              `${formData.brandGuideItemList[i].id}.jpeg`
            )
          })
          setFormImg((prevState) => {
            prevState.push(formData.brandGuideItemList[i].imageUrl)
            return [...prevState]
          })
        }
      }
    }, 500)
  }, [keys])

  function add() {
    const keys = getFieldValue('keys')
    const index = keys.length
    if (!isEmpty(keys)) {
      keys.push({
        id: index,
        idx: index
      })
      setFieldsValue({
        keys: keys
      })
      setFormImg((prevState) => {
        prevState.push('')
        return [...prevState]
      })
    } else {
      keys.push({
        id: index,
        idx: index
      })
      setFieldsValue({
        keys: keys
      })
      setFormImg([])
    }
  }

  function remove(e, k, idx) {
    e.preventDefault()
    const keys = getFieldValue('keys')
    if (k !== 0) {
      setFieldsValue({
        keys: keys.filter((key) => key.id !== k)
      })
    } else {
      setFieldsValue({
        keys: keys.filter((key, index) => index !== idx)
      })
    }
  }

  function onClickAddMaterial(e, item, index) {
    e.preventDefault()
    // const material = find(formData.brandGuideItemList, ['id', item.id])
    // console.log('material', material)
    setMaterialForm(item)
    setVisibleAddMaterial(true)
  }

  function onOkAddMaterial(data) {
    for (const item of keys) {
      if (data.idx) {
        if (data.idx === item.idx) {
          item.materialId = data.materialId
          item.materialName = data.materialName
          item.materialImageUrl = data.materialImageUrl
        }
      } else {
        if (data.id === item.id && data.id !== 0) {
          item.materialId = data.materialId
          item.materialName = data.materialName
          item.materialImageUrl = data.materialImageUrl
        }
      }
    }
    setVisibleAddMaterial(false)
  }

  function onClose() {
    setVisibleAddMaterial(false)
  }

  async function handleChange(info, index) {
    await getBase64(info.file, (imageUrl) => {
      setFormImg((prevState) => {
        prevState[index] = imageUrl
        return [...prevState]
      })
    })
  }

  async function uploadBrandGuideImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/brand/image-guide-item`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )

      return res.data.url
    } catch (err) {
      return null
    }
  }
  async function uploadBrandImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/brand/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
      )

      return res.data
    } catch (err) {
      return null
    }
  }
  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  async function coverHandleChange(info) {
    await getBase64(info.file, (coverImageUrl) => {
      setCoverImageUrl(coverImageUrl)
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const { keys, images, recycleDetails, weights } = values
        const recycleDetailData = keys.map((key) => recycleDetails[key.id])
        const weightData = keys.map((key) => weights[key.id])
        const imageData = keys.map((key) => images[key.id])
        const data = []

        for (let i = 0; i < keys.length; i++) {
          data.push({
            barcodeId: formData.barcodeId,
            materialId: keys[i].materialId,
            recycleDetail: recycleDetailData[i],
            recycleIndex: i,
            weight: weightData[i]
          })
        }

        for (let i = 0; i < data.length; i++) {
          if (!isUndefined(imageData[i])) {
            if (!isUndefined(imageData[i].file)) {
              data[i].imageUrl = await uploadBrandGuideImage(imageData[i].file)
            } else {
              data[i].imageUrl = formData.brandGuideItemList[i].imageUrl
            }
          }
          if (!isEmpty(formData)) {
            data[i].id = formData.brandGuideItemList[i]
              ? formData.brandGuideItemList[i].id
              : 0
          }
        }
        const productData = {
          name: values.name,
          brand: values.brand,
        }
        if (values.coverImage) {
          const img = await uploadBrandImage(values.coverImage.file)
          productData.barcodeImageId = img.id
        } else {
          productData.barcodeImageId = formData.barcodeImageId
        }
        if (!_.isEmpty(formData)) {
          productData.barcodeId = formData.barcodeId
        }  
         onOk(data,productData)
      }
    })
  }

  return (
    <Modal
      width={700}
      title="เพิ่มวิธีคัดแยก"
      visible={visible}
      closable={false}
      footer={null}>
      <BarcodeMaterialModal
        materialForm={materialForm}
        visible={visibleAddMaterial}
        onOk={onOkAddMaterial}
        onCancel={onClose}
      />
      <Row gutter={[8, 8]} >
        <Form onSubmit={handleSubmit}>
          <Col span={24}>
            <Row justify="center">
              <Col span={6}>
                <Row style={{ marginTop: '30px' }}
                  type="flex"
                  justify="center"
                  align="middle">
                  <Col>
                    {getFieldDecorator(`coverImage`, {
                      rules: [
                        {
                          required: isNull(formData),
                          message: 'เลือกรูปภาพ'
                        }
                      ]
                    })(
                      <Upload
                        name="img"
                        listType="picture-card"
                        showUploadList={false}
                        beforeUpload={(file) => beforeUpload(file)}
                        onChange={coverHandleChange}
                      >
                        {coverImageUrl ? (
                          <img src={coverImageUrl} alt="img" width={120}
                            height={120} />
                        ) : (
                          uploadButton
                        )}
                      </Upload>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={12} >
                <Row
                  justify="left"
                  align="middle">
                  <Form.Item label="ยี่ห้อสินค้า :">
                    {getFieldDecorator(`brand`)
                      (<Input
                        name="brand"
                        placeholder="ยี่ห้อสินค้า" />)}
                  </Form.Item>
                </Row>
                <Row
                  justify="left"
                  align="middle">
                  <Form.Item label="ชื่อสินค้า :">
                    {getFieldDecorator(`name`)
                      (<Input
                        name="name"
                        placeholder="ชื่อสินค้า" />)}
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              {!isEmpty(keys) &&
                keys.map((item, index) => {
                  return (
                    <Col span={24} key={index}>
                      <Card>
                        <Row gutter={[8, 8]}>
                          <Col span={24}>
                            <Row type="flex" justify="space-between">
                              <Col>ขยะชิ้นที่ {index + 1}</Col>
                              <Col>
                                <Button
                                  type="danger"
                                  onClick={(e) => remove(e, item.id, index)}>
                                  ลบ
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row type="flex">
                              <Col span={8}>
                                <Row type="flex" justify="center">
                                  <Form.Item
                                    key={item.id === 0 ? item.idx : item.id}>
                                    {getFieldDecorator(
                                      `images[${item.id === 0 ? item.idx : item.id
                                      }]`,
                                      {
                                        rules: [
                                          {
                                            required: isNull(formData),
                                            message: 'เลือกรูปภาพ'
                                          }
                                        ]
                                      }
                                    )(
                                      <Upload
                                        name="avatar"
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={(file) =>
                                          beforeUpload(file)
                                        }
                                        onChange={(info) =>
                                          handleChange(info, index)
                                        }>
                                        {!isEmpty(formImg) ? (
                                          formImg[index] ? (
                                            <img
                                              src={formImg[index]}
                                              alt="avatar"
                                              width={114}
                                              height={114}
                                            />
                                          ) : (
                                            <img
                                              src={SelectImg}
                                              alt=""
                                              width={114}
                                              height={114}
                                            />
                                          )
                                        ) : (
                                          <img
                                            src={SelectImg}
                                            alt=""
                                            width={114}
                                            height={114}
                                          />
                                        )}
                                      </Upload>
                                    )}
                                  </Form.Item>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <Row
                                  style={{ marginTop: '30px' }}
                                  type="flex"
                                  justify="center"
                                  align="middle">
                                  <Col>
                                    <Icon
                                      type="arrow-right"
                                      style={{ fontSize: 64 }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <Row type="flex" justify="center">
                                  {item.materialImageUrl ? (
                                    <SelectMaterialDiv
                                      onClick={(e) =>
                                        onClickAddMaterial(e, item, index)
                                      }>
                                      <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                          <Row type="flex" justify="center">
                                            <Row type="flex" justify="center">
                                              <img
                                                src={item.materialImageUrl}
                                                alt=""
                                                width={64}
                                                height={64}
                                              />
                                            </Row>
                                          </Row>
                                        </Col>
                                        <Col span={24}>
                                          <Row type="flex" justify="center">
                                            <span>{item.materialName}</span>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </SelectMaterialDiv>
                                  ) : (
                                    <img
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) =>
                                        onClickAddMaterial(e, item, index)
                                      }
                                      src={AddMaterialImg}
                                      alt=""
                                      width={128}
                                      height={128}
                                    />
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="วิธีคัดแยก"
                              key={item.id === 0 ? item.idx : item.id}>
                              {getFieldDecorator(
                                `recycleDetails[${item.id === 0 ? item.idx : item.id
                                }]`,
                                {
                                  rules: [
                                    {
                                      required: true,
                                      whitespace: true,
                                      message: 'กรุณากรอก'
                                    }
                                  ]
                                }
                              )(<Input.TextArea autoSize={{ minRows: 3 }} />)}
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Row>
                              <Col span={6}>
                                <Form.Item
                                  label="น้ำหนัก"
                                  key={item.id === 0 ? item.idx : item.id}>
                                  {getFieldDecorator(
                                    `weights[${item.id === 0 ? item.idx : item.id
                                    }]`,
                                    {
                                      rules: [
                                        {
                                          required: true,
                                          message: 'กรุณากรอก'
                                        }
                                      ]
                                    }
                                  )(<InputNumber min={0.00001} step={0.00001} />)}
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  )
                })}
            </Row>
            <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
              <Col span={24}>
                <Row type="flex" justify="center" gutter={8}>
                  <Col>
                    <Button onClick={() => add()}>เพิ่มขยะ</Button>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row type="flex" justify="center" gutter={8}>
                  <Col>
                    <Button
                      onClick={() => {
                        // resetFields()
                        onCancel()
                        // setFormImg([])
                      }}>
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit">
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Form>
      </Row>
    </Modal>
  )
}

const WrappedBrandGuideItem = Form.create({ name: 'BrandGuideItem' })(
  BrandGuideItem
)
export default WrappedBrandGuideItem



// WEBPACK FOOTER //
// ./src/pages/BrandProduct/BrandGuideItem/index.js